export default __webpack_public_path__ + "static/media/PromoRed.20ed535a.svg";